
// https://van11y.net/fr/

export default class WhoBlockAccordion {

    constructor() {
        // console.log( jQuery('.js-accordion') ) ;
        // jQuery('.js-accordion').accordion();

        var my_accordion = van11yAccessibleAccordionAria();
        my_accordion.attach();
    }

}